export default "__VITE_ASSET__C6vzbc6d__"